module.exports = __webpack_public_path__ + "static/media/A5.61c73a0f.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A5.png
// module id = 871
// module chunks = 0